module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Caitlin Ricci\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Caitlin is the author of over 150 queer romance books including some Rainbow Award winners. When she’s not writing, she enjoys gardening, hanging out with her dogs, and watching movies with her husband. She is a panromantic asexual and she lives on a small farm in Missouri where she enjoys the quiet life of a good cup of tea and her dogs asleep on the deck.")]), _c('P', [_vm._v("Website: www.CaitlinRicci.com")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/B8OF9F/Images/cover.jpg?1685327317291",
      "alt": "This image is the cover for the book Crush"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Crush\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Going to college gives eighteen-year-old Trey Porter a chance to experience the world beyond rural Alabama and his overbearing family. After staying in a motel due to a housing error at the school, Trey’s friend, Bryce, offers to let Trey stay with him. The fascination Trey feels with Bryce’s gorgeous, glamorous, and somewhat outrageous boyfriend, Co-Co, catches him totally off guard, because Trey’s never considered himself even remotely gay. At least that’s what he’s always believed. Trey prides himself on being tolerant, but it’s hard to handle the questions he faces about life and himself—and even harder to accept that there might be no simple answers.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0